const FACULTY_MAP = {
  lc: '言語文化学部',
  ia: '国際社会学部',
  js: '国際日本学部',
  pg: '大学院総合国際学研究科',
  gla: '世界教養プログラム',
};

const CATEGORY_MAP = {
  lnc: '専攻言語',
  ge: '教養',
  intro: '導入',
  adv: '専門',
};

const normalizeAcademicYear = (value) => (String(value ?? '').match(/\d{4}/) || [])[0] || '';

/**
 * Convert slot-based syllabus rows (dayOfWeek1..5/period1..5) into the
 * flat Course shape consumed by the search screen and course cards.
 */
const expandSlotBasedSyllabusRows = (rows) => rows.flatMap((row) => {
  const baseCourse = {
    id: String(row.id ?? ''),
    name: row.title || '',
    title: row.name || '',
    professor: row.professor,
    room: row.room,
    semester: row.semester,
    language: row.language,
    courseCode: row.courseCode,
    faculty: FACULTY_MAP[row.faculty] || row.faculty,
    facultyCode: row.faculty,
    category1: row.category1,
    category2: row.category2,
    academicYear: normalizeAcademicYear(row.academicYear)
      ? `${normalizeAcademicYear(row.academicYear)}年度`
      : undefined,
    category: CATEGORY_MAP[row.category1] || row.category1 || '全',
  };

  const slots = [];
  for (let i = 1; i <= 5; i += 1) {
    const day = row[`dayOfWeek${i}`];
    const period = row[`period${i}`];
    if (day !== null && day !== undefined && period !== null && period !== undefined) {
      slots.push({ dayOfWeek: Number(day), period: Number(period) });
    }
  }

  if (slots.length === 0) {
    return [{ ...baseCourse, dayOfWeek: undefined, period: undefined }];
  }

  return slots.map((slot) => ({ ...baseCourse, ...slot }));
});

module.exports = { expandSlotBasedSyllabusRows };
